// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"7f70469d","112":"c8e2f207","606":"278e9947","732":"bd0448eb","810":"f00b9032","989":"044d9e2d"}[chunkId] + ".css";
};